import React from "react";

import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import MealRatingLogs from "./components/MealRatingLogs";
import MealRatingReport from "./components/MealRatingReport";
import WeeklyRating from "./components/WeeklyRating";

const useStyles = makeStyles()(() => ({
  container: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    marginTop: 20,
    marginInline: 10,
  },
  mealRatingLogContainer: {
    backgroundColor: "#fff",
    flex: 1,
    marginRight: 20,
  },
  weeklyRatingContainer: {
    backgroundColor: "#fff",
    flex: 2,
    marginRight: 20,
  },
  mealRatingReportContainer: {
    backgroundColor: "#fff",
    flex: 2,
  },
}));

const ClientMealRatingsPage: React.FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.mealRatingLogContainer}>
        <MealRatingLogs />
      </Box>
      <Box className={classes.weeklyRatingContainer}>
        <WeeklyRating />
      </Box>
      <Box className={classes.mealRatingReportContainer}>
        <MealRatingReport />
      </Box>
    </Box>
  );
};

export default ClientMealRatingsPage;
